<template>
  <section class="block-main">
    <div class="block-main__container container">
      <div class="block-main__content">
        <div class="block-main__text">
          <h1 class="block-main__title">
            <b>Снижаем цены</b> В АВТОМИР! <br />
            Распродажа склада автомобилей <b>GEELY!</b> <br />
            <b class="red-text">Двойная</b> выгода!
            <b class="red-text">Рассрочка</b>!*
          </h1>
          <!-- <h2 class="block-main__subtitle">
          Снижаем цены на а/м GEELY!
          <p><span class="red">Двойная</span> выгода!</p>
        </h2> -->
        </div>

        <button
          class="block-main__btn button button_theme_primary"
          @click="getCall"
        >
          Получить максимальную выгоду
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Mixin from "../common/mixin";

export default {
  name: "block-main",
  mixins: [Mixin],
  data() {
    return {};
  },
  methods: {
    handleCallback(data) {
      this.$emit("callBack", data);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.block-main {
  background-image: url("../images/background/main.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  // background-position: 65% 50%;
  background-position: bottom;
  height: calc(800 / 1920 * 100vw);
  max-height: 800px;
  overflow: hidden;
  padding-top: 50px;

  &__container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
  }

  &__text {
    color: #fff;
    padding: 10px;
    background: rgba(0, 0, 0, 0.6);
  }

  &__title {
    font-size: calcFontSize(20, 45, 640, 1920);
    font-weight: 500;
    text-transform: uppercase;

    b {
      font-weight: 700;
    }
  }

  &__subtitle {
    font-size: 40px;
    font-weight: normal;
    text-transform: uppercase;
  }

  &__btn {
    width: auto;
    min-width: 300px;
    padding: 22px 22px;
    font-size: 18px;
    margin-top: 10px;
  }

  &__img {
    display: none;
  }
}

@media (max-width: 800px) {
  .block-main {
    height: calc(100vw * 600 / 800);
    text-align: center;
    padding-top: 15px;

    &__container {
      align-items: center;
    }

    &__btn {
      font-size: 14px;
      height: 40px;
      margin: 10px auto 0;
    }
  }
}

@media (max-width: 640px) {
  .block-main {
    background-image: url("../images/background/main_m.jpg");
    background-position: center;
    min-height: calc(100vw * 325 / 323);
    &__title {
      font-size: 28px;
    }

    &__subtitle {
      font-size: 24px;
    }
  }
}

@media (max-width: 480px) {
  .block-main {
    &__title {
      font-size: 18px;
      margin-bottom: 8px;
    }

    &__subtitle {
      font-size: 14px;
    }
  }
}
</style>
